import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavigationIcon from '../../Icon/NavigationIcon.tsx';
import styles from '../../Navigation.less';
import actions from '../../actions.js';
import { getPageViewId, isSidebarExpanded } from '../../../../selectors/selectors.js';
import MenuIcon from '../../Menu/MenuIcon';

import tracking from '../../../../tracking/tracking';
import { INTERACTIVE_ATLAS_NAVI_COLLAPSE, INTERACTIVE_ATLAS_NAVI_EXPAND } from '../../../../tracking/trackingNaming';

export const ChevronLeft = () => <MenuIcon className="is24-icon-chevron-left" fontSize="18px" />;
export const ChevronRight = () => <MenuIcon className="is24-icon-chevron-right" fontSize="18px" />;

export const NavigationToggleButton  = ({ sidebarExpanded, pageTitle, onClick, reportData }) => (
  <div className={`grid grid-flex ${styles.sidebar_toggle} ${sidebarExpanded ? styles.expanded : ''}`}>
    <button
      type="button"
      id="toggle"
      className="lap-one-whole"
      onClick={(event) => {
        onClick(!sidebarExpanded);
        const label = sidebarExpanded ? INTERACTIVE_ATLAS_NAVI_COLLAPSE : INTERACTIVE_ATLAS_NAVI_EXPAND;
        reportData({ label, pageTitle });
        event.stopPropagation();
        event.preventDefault();
      }}
    >
      <NavigationIcon Icon={sidebarExpanded ? ChevronLeft : ChevronRight} color="#333333" />
    </button>
  </div>
);

NavigationToggleButton.defaultProps = {
  sidebarExpanded: false,
  reportData: tracking.reportData,
};

NavigationToggleButton.propTypes = {
  sidebarExpanded: PropTypes.bool,
  reportData: PropTypes.func,
};

const mapStateToProps = (state) => ({
  sidebarExpanded: isSidebarExpanded(state),
  pageTitle: getPageViewId(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClick: (value) => dispatch(actions.toggleSidebar(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavigationToggleButton);
